module.exports = __webpack_public_path__ + "img/invigorate.62a252f7.png";